export default __webpack_public_path__ + "static/media/rubella-graph.969acfdb.svg";